import { render, staticRenderFns } from "./AlteracoesAssociacaoPendentesSistema.vue?vue&type=template&id=6b52856a"
import script from "./AlteracoesAssociacaoPendentesSistema.vue?vue&type=script&lang=ts"
export * from "./AlteracoesAssociacaoPendentesSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports